export const SET_PREFERRED_PAGE_GROUP = 'main:cause:fundraiser:set-preferred:';
export const SET_PREFERRED_PAGE_LANDING =
  'main:cause:fundraiser:set-preferred:landing';
export const SET_PREFERRED_PAGE_SET_PREFERRED =
  'main:cause:fundraiser:set-preferred:set-preferred-page';
export const SET_PREFERRED_PAGE_CONFIRMATION =
  'main:cause:fundraiser:set-preferred:confirmation';
export const HUB_PAGE_GROUP = 'main:cause:fundraiser:hub:';
export const HUB_PAGE_LANDING = 'main:cause:fundraiser:hub:landing';
export const HUB_PAGE_SEARCH_PAGE = 'main:cause:fundraiser:hub:search';
export const HUB_PAGE_PROFILE_PAGE = 'main:cause:fundraiser:hub:profile';
export const CAMPAIGN_PAGE_GROUP = 'main:cause:fundraiser:campaign:';
export const CAMPAIGN_MULTI_CHARITY_LANDING = 'main:cause:fundraiser:campaign:multi-charity:landing';
export const CAMPAIGN_ALL_CHARITY_LANDING = 'main:cause:fundraiser:campaign:all-charity:landing';
export const CAMPAIGN_PROFILE_PAGE = 'main:cause:fundraiser:campaign:profile';
export const CAMPAIGN_SEARCH_PAGE = 'main:cause:fundraiser:campaign:search';
